
(function (webview_product, $, undefined) {

    // public configuration variable
    webview_product.config = {};

    // bind events and such to the DOM
    // private function
    function bindEvents() {
        $(window).on('load', function () {
            webview_product.tabs();
            webview_product.categoryFilter();
            webview_product.productGrid();
        });

        $(window).on('resize', function () {

        });
    }

    webview_product.tabs = function () {
        //product tabs (directions, details, and reviews)
        var $tab = $('.webview-tabs li');

        $tab.on('click', function () {

            var $this = $(this);

            $tab.removeClass("active");
            $this.addClass("active");

            $('.tabs-wrap .webview-tab-content').removeClass("active");

            var tabHeading = $(this).text().replace(' ', '-');
            $('.tabs-wrap .webview-tab-content.' + tabHeading).addClass("active");
        });
    }

    webview_product.categoryFilter = function () {
        var $mobileHeader = $('.mobile-filter-header');

        $mobileHeader.on('click', function (e) {
            $mobileHeader.toggleClass('collapsed').toggleClass('open');
        });
    }

    webview_product.productGrid = function () {
        var $productGridPreviews = $('.product-grid-preview .page-preview');
        var $productGridItems = $('.product-grid-list .product-grid-item');

        //set first active products
        $('.product-grid-preview .page-preview:first-child').addClass('active');

        $productGridItems.on('click', function (e) {
            var $this = $(this);
            var index = $this.index();

            $productGridPreviews.removeClass('active');
            $productGridPreviews.eq(index).addClass('active');

            //scroll up to top product heading for viewing preview
            $('body,html').animate({
                scrollTop: $('#productJump').offset().top
            }, 500);
        });
    }

    // initialize object
    // this is a public function
    webview_product.init = function () {
        bindEvents();
    }
})(window.webview_product = window.webview_product || {}, jQuery);



// WEBPACK FOOTER //
// ./Content/js/app/webview-product.js